"use strict";

import angular from "angular";

const name = "removeIfContract";
const factory = [
    "ContractService",
    (ContractService) => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            if (!$attr.removeIfContract) return;
            const contract = $attr.removeIfContract.split(",");
            const isContracted = ContractService.isContracted(contract);
            if (!isContracted) $elem.remove();
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
